import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { Link, useNavigate } from "react-router-dom";
import DaumPostcode from 'react-daum-postcode';
import {CgSearch} from 'react-icons/cg'
import axios from 'axios';
import { useSelector } from 'react-redux';
import { TextField, Modal, Button, Box, Typography, Dialog, DialogActions, DialogTitle, DialogContentText, DialogContent } from '@mui/material'
import mainPath from '../../../utils/path';
import { TbLoader } from 'react-icons/tb';

let date = new Date();
let year = date.getFullYear();
let month = date.getMonth();
let day = date.getDate();

month += 1;

if (month <= 9){
    month = "0" + month;
}

if (day <= 9){
    day = "0" + day;
}

let today = year + '-' + month + '-' + day;




const useStyles = makeStyles((theme) => ({
    row:{
        maxWidth:'1280px', 
        margin:'0 auto', 
        padding:'310px 0 70px 0',

        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
            padding:'150px 0 0px 0',
        }
    },
    appListH3:{
        borderBottom:'2px solid #007235',
        fontSize:'22px',
        fontWeight:'400',
        paddingBottom:'10px'
    },
    DeliveryorderFlexDiv:{
        display:'flex',
        justifyContent:'space-evenly',
        paddingTop:'3%',

        [theme.breakpoints.down(1025)]: {
            flexDirection: 'column'
        }
    },
    DeliveryForm:{
        width:'38%',

        [theme.breakpoints.down(1025)]: {
            width:'100%',
            padding:'0 20px',
        }
    },
    appListLi:{
        padding:'40px 0 0 0px'
    },
    idOverlapDiv:{
        display:'flex',
        justifyContent:'space-between',
    },
    appContentId:{
        width:'72%'
    },
    appContentInputId:{
        width:'100%',
        height: '40px',
        padding:'0 0 0 8px',
        borderRadius:'3px',
        border:'1px solid #CCCCCC',
        '&::placeholder':{
            color:'#CCCCCC'
        },
        '&:focus-within':{
            outline:'none'
        },
        
    },
    paddingDiv:{
        paddingBottom:'10px'
    },
    pilsooItem:{

    },
    appContentIdBtn:{
        width:'25%'
    },
    pilsooItemIdBtn:{
        width:'100%',
        height: '40px',
        padding:'5px 0px',
        background:'none',
        border:'1px solid #007235',
        borderRadius:'3px',
        color:'#007235',
    },
    appContentInput:{
        width:'100%',
        height: '40px',
        padding:'0 0 0 8px',
        borderRadius:'3px',
        border:'1px solid #CCCCCC',
        '&::placeholder':{
            color:'#CCCCCC'
        },
        '&:focus-within':{
            outline:'none'
        },
    },
    totalPriceDiv:{
        display:'flex',
        justifyContent:'space-around',
        paddingTop:'20px'
    },
    totalPriceLeftH1:{
        fontSize:'16px',
        letterSpacing: '-0.8px',
    },
    totalPriceRightH1:{
        fontSize:'24px',
        letterSpacing: '-1.2px',
    },
    btnDiv:{
        textAlign:'center',
        margin:'50px 0',
        [theme.breakpoints.down(1025)]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    orderForm:{
        width:'40%',

        [theme.breakpoints.down(1025)]: {
            width:'100%',
            padding:'20px 20px 0 20px',
        }
    },
    totalDiv:{
        borderBottom:'2px solid #CCCCCC',
        padding:'15px 0',
    },
    tableTh:{
    },
    tableData:{
        height:'170px',
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    productInformationImg:{
        width:'150px',
        height:'150px',
    },
    topBtnLeft:{
        margin:'0 15px 0 0'
    },
    orderBtnLeft:{
        marginTop:'30px',
        padding:'10px 0',
        width:'78%',
        background:'#007235',
        color:'#fff',
        fontSize:'16px',
        borderRadius: '3px',

        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            width:'100%',
        }
    },
    orderBtnRight:{
        marginTop:'30px',
        padding:'10px 0',
        width:'20%',
        background:'#DDDDDD',
        color:'#232323',
        fontSize:'16px',
        borderRadius: '3px',

        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            width: 60,
        }
    },
    thead1: {
        display : 'flex',
        borderBottom:'2px solid #CCCCCC',
        paddingBottom: 8,
        [theme.breakpoints.down(1025)]: {
            display: 'none'
        }
    },
    t1: {
        display: 'flex',
        alignItems: 'center',
        flex: 3,
    },
    t2: {
        flex: 1,
        [theme.breakpoints.down(1025)]: {
            display: 'none'
        }
    },
    t3: {
        [theme.breakpoints.down(1025)]: {
            height: '100%',
            paddingLeft: 10,
            display: 'flex',
            flexDirection : 'column',
        }
    },
    t4: {
        display: 'none',
        [theme.breakpoints.down(1025)]: {
            display: 'block',
        }
    },
    t5: {
        paddingLeft: 5,
        [theme.breakpoints.down(1025)]: {
            paddingLeft: 0,
        }
    },
    load:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
      },
      loadingIcon:{
        color:'#007235',
        fontSize:'50px',
        animation:'$loadSpin 5s infinite'
      },
      "@keyframes loadSpin":{
        from: { transform:'rotate(0deg)' },
        to: { transform:'rotate(1turn)' }
      },
      addStyle: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '2px solid #007235',
        borderRadius:3,
        boxShadow: 24,
        p: 4,
        [theme.breakpoints.down(1025)]: {
            width:'100%',
        }
    },
}))


const DeliveryInformation = ({ctList}) => {
    let navigate = useNavigate();
    const mbId = useSelector(state => state.user.userInfo['mb_id']);
    const sendCost = parseInt(useSelector(state => state.config.shopDefaultConfig.de_send_cost_list));
    const pointUnit = useSelector(state => state.config.shopDefaultConfig.de_settle_point_unit)
    const minPoint = useSelector(state => state.config.shopDefaultConfig.de_settle_min_point)
    const maxPoint = useSelector(state => state.config.shopDefaultConfig.de_settle_max_point)
    const bankAccount = useSelector(state => state.config.shopDefaultConfig.de_bank_account)
    const hopeDateAfter = useSelector(state => state.config.shopDefaultConfig.de_hope_date_after)
    const login = useSelector(state => state.user.login);
    const [data, setData] = useState([])
    const [mbInfo, setMbInfo] = useState()

    const [open, setOpen] = useState(false);

    const [nameB, setNameB] = useState('')
    const [emailB, setEmailB] = useState('')
    const [hpB, setHpB] = useState('')
    const [zip1B, setZip1B] = useState('')
    const [zip2B, setZip2B] = useState('')
    const [addr1B, setAddr1B] = useState('')
    const [addr2B, setAddr2B] = useState('')
    const [addr3B, setAddr3B] = useState('')

    const [nameDepo, setNameDepo] = useState('')
    const [point, setPoint] = useState(0)
    const [shopMemo, setShopMemo] = useState('')
    const [hopeDate, setHopeDate] = useState('')

    const [ctItms, setCtItms] = useState([])

    const [dialog, setDialog] = useState('');
    const [dialogQty, setDialogQty] = useState([])

    const [deliLoading, setDeliLoading] = useState(false);

    const theme = useTheme();
    const classes = useStyles(theme);

    const getItem = async() => {
        if(ctList.length === 0 || !ctList) {
            navigate("/Cart");
            return
        }

        try {
            const res = await axios.post('/api/shop/orderInfo/', {ctList: ctList, mb_id: mbId})
      
            if(res.data.success === false) {
                setDialog('불러오기 실패')
                return;
            }

            setData(res.data.result)
            setMbInfo(res.data.mbInfo)
            setCtItms(res.data.result.reduce((result, item) => ([...result, item['it_id']]), []))
        
          } catch (e) {
            console.log(e)
          }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (!login) {
          navigate("/");
        }
    } , [login])

    useEffect(() => {
        if (mbId) {
            getItem()
        }
    } ,[mbId])

    useEffect(() => {

        return () => {
            setData([])
            setMbInfo()
            setOpen(false)
            setNameB('')
            setEmailB('')
            setHpB('')
            setZip1B('')
            setZip2B('')
            setAddr1B('')
            setAddr2B('')
            setAddr3B('')
            setNameDepo('')
            setPoint(0)
            setShopMemo('')
            setHopeDate('')
        }
      }, [])

    const handle = {
        // 버튼 클릭 이벤트
        handleOpen: () => {
            setOpen(current => !current);
        },

        // 주소 선택 이벤트
        selectAddress: (data) => {
            let zip1 = data.zonecode.substr(0, 3);
            let zip2 = data.zonecode.substr(3, 3);
            let addr1 = data.address

            setZip1B(zip1)
            setZip2B(zip2)
            setAddr1B(addr1)
            setOpen(false);
        },
    }

    const onOrder = async() => {
        let ctoday = new Date();   
        let chours = ctoday.getHours()
        let cmin = ctoday.getMinutes()
        if (chours < 13 || chours > 20 || (chours > 19 && cmin > 30 )) {
            setDialog('주문가능 시간은 오후 1시에서 오후 8시 30분 사이 입니다.')
            setDeliLoading(false)
            return
        }

        if(data.length === 0) {
            setDialog('주문할 상품이 없습니다.')
            setDeliLoading(false)
            return
        } 
        if(nameB === '') {
            setDialog('수령인/배송지명을 입력해 주세요.')
            setDeliLoading(false)
            return
        }
        if(emailB === '') { 
            setDialog('이메일을 입력해 주세요.')
            setDeliLoading(false)
            return
        }
        if(hpB === '') { 
            setDialog('휴대폰 번호를 입력해 주세요.')
            setDeliLoading(false)
            return
        }
        if(zip1B === '') { 
            setDialog('주소를 입력해 주세요.')
            setDeliLoading(false)
            return
        }
        if(addr2B === '') { 
            setDialog('상세주소를 입력해 주세요.')
            setDeliLoading(false)
            return
        }
        if(nameDepo === '') { 
            setDialog('입금자명을 입력해 주세요.')
            setDeliLoading(false)
            return
        }

        let ip = ''
        let dayH = ''
        let cartCount = data.reduce((result, item) => result + item['ct_qty'], 0)
        let cartPrice = data.reduce((result, item) => result + (item['ct_price'] * item['ct_qty']), 0)
        

        if (hopeDate !== '') {
            const today1 = new Date(today);
            const hopeday = new Date(hopeDate);

            if(hopeday <= today1) {
                setDialog('희망배송일은 다음날 부터 선택 가능합니다.!')
                setDeliLoading(false)
                return
            }
            dayH = hopeDate
        } else {
            let date2 = new Date();
            date2.setDate(date2.getDate() + 1);
            let yeart2 = date2.getFullYear().toString()
            let montht2 = date2.getMonth()+1
            let dayt2 = date2.getDate()

            if (montht2 <= 9){
                montht2 = "0" + montht2;
            }
            
            if (dayt2 <= 9){
                dayt2 = "0" + dayt2;
            }

            if (montht2 > 12) {
                montht2 = "01"
            }

            let tomm2 = yeart2 + '-' + montht2 + '-' + dayt2

            let date22 = new Date(tomm2);
            if (date22.getDay() === 6 || date22.getDay() === 0) { 
                setDialog('주말 배송은 불가합니다.') 
                setDeliLoading(false)
                return
            }

            dayH = tomm2
        }


        // 재고 확인

        try {
            const res = await axios.post('/api/shop/getItmQty/', 
                {
                    itm_list: ctItms
                }
            )
      
            if(res.data.success === false) {
                setDialog('재고불러오기 실패')
                setDeliLoading(false)
                return;
            }
            let soldOuts =[]
            let qtyRes = res.data.result
            data.forEach((itm) => {
                if (qtyRes[itm['it_id']] - itm['ct_qty'] < 0) {
                    soldOuts.push({it_name: itm['it_name'], it_qty: qtyRes[itm['it_id']]})
                }
            })

            if (soldOuts.length > 0) {
                setDialogQty(soldOuts)
                return
            }
        
          } catch (e) {
            console.log(e)
            setDeliLoading(false)
          }


        // try {
        //   const response = await axios.get('https://api.ipify.org?format=json');
        //   ip = response.data.ip;
        // } catch (error) {
        //   console.error(error);
        //   setDeliLoading(false)
        //   return
        // }

        try {
            const res = await axios.post('/api/shop/orderItem/', 
                {
                    ct_id_list: ctList,
                    mb_id: mbId,
                    od_deposit_name: nameDepo,
                    od_b_name: nameB,
                    od_b_hp: hpB,
                    od_b_zip1: zip1B,
                    od_b_zip2: zip2B,
                    od_b_addr1: addr1B,
                    od_b_addr2: addr2B,
                    od_b_addr3: addr3B,
                    od_cart_count: cartCount,
                    od_cart_price: cartPrice,
                    od_send_cost: sendCost,
                    od_receipt_point: point,
                    od_bank_account: bankAccount,
                    od_hope_date: dayH,
                    od_ip: ip,
                    od_memo: shopMemo
                }
            )
      
            if(res.data.success === false) {
                setDialog('주문 실패')
                setDeliLoading(false)
                return;
            }

            setDialog('주문성공')
            navigate("/OrderSuccess");
        
          } catch (e) {
            console.log(e)
            setDeliLoading(false)
            return
          }

    }
    

    return(
        <div>

<div className={classes.DeliveryInformationBlock}>
                <div className={classes.row}>
                    <div className={classes.DeliveryorderFlexDiv}>
                        <div className={classes.DeliveryForm}>
                            <h3 className={classes.appListH3}>배송지 정보</h3>
                            <Button 
                                style={{ 
                                    color:'#007235', 
                                    float:'right', 
                                    fontWeight:'700', 
                                    fontSize:'16px',

                                    fontFamily:[
                                        'Noto Sans KR'
                                    ]
                                }}
                                onClick={() => {
                                    setNameB(mbInfo['mb_name'])
                                    setEmailB(mbInfo['mb_email'])
                                    setHpB(mbInfo['mb_hp'])
                                    setZip1B(mbInfo['mb_zip1'])
                                    setZip2B(mbInfo['mb_zip2'])
                                    setAddr1B(mbInfo['mb_addr1'])
                                    setAddr2B(mbInfo['mb_addr2'])
                                    setAddr3B(mbInfo['mb_addr3'])
                                    setNameDepo(mbInfo['mb_name'])
                                }} 
                            >
                                기본주소
                            </Button>
                            <p style={{fontSize: 15, paddingTop:15}}>기본주소 클릭시 회원정보에 저장된 정보를 불러옵니다.</p>
                            <p style={{fontSize: 15, paddingTop:3}}>기본주소가 나오지 않을시 회원정보 수정 부탁드립니다.</p>
                            <ul className={classes.appList}>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>수령인/배송지명</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='수령받으실 성함을 입력해주세요.' 
                                            value={nameB}
                                            onChange={(e) => {setNameB(e.target.value)}}
                                        />
                                    </div>
                                </li>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>이메일</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='이메일을 입력해주세요.' 
                                            value={emailB}
                                            onChange={(e) => {setEmailB(e.target.value)}}
                                        />
                                    </div>
                                </li>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>휴대전화</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='숫자만 입력해주세요.' 
                                            value={hpB}
                                            onChange={(e) => {setHpB(e.target.value)}}
                                        />
                                    </div>
                                </li>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>배송지 주소</label>
                                    </div>
                                    <div>
                                        <Button 
                                            onClick={() => setOpen(true)} 
                                            style={{
                                                background:'#fff',
                                                color:'#007235',
                                                border:'1px solid #007235',
                                                width:'100%',
                                                marginBottom:'10px',
                                            }}
                                        >
                                            <CgSearch />
                                            주소검색
                                        </Button>
                                        <Modal
                                            open={open}
                                            onClose={() => setOpen(false)}
                                        >
                                            <Box sx={classes.addStyle}>
                                                <Typography 
                                                    id="modal-modal-description" 
                                                    variant="span" 
                                                    sx={{ 
                                                        mt: 2,
                                                    }}                                               
                                                >
                                                    <DaumPostcode 
                                                        onComplete={handle.selectAddress}  // 값을 선택할 경우 실행되는 이벤트
                                                        autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정 
                                                    />
                                                </Typography>
                                            </Box>
                                        </Modal>    
                                    </div>
                                    <div className={classes.appContent}>
                                        <h3>{zip1B + zip2B}</h3>
                                        <h3>{addr1B}</h3>

                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='상세주소를 입력해주세요' 
                                            value={addr2B}
                                            onChange={(e) => {setAddr2B(e.target.value)}}
                                        />
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='상세주소를 입력해주세요 (선택)' 
                                            value={addr3B}
                                            onChange={(e) => {setAddr3B(e.target.value)}}
                                        />
                                    </div>

                                </li>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>입금자명</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='입금자 성함을 입력해주세요.' 
                                            value={nameDepo}
                                            onChange={(e) => {setNameDepo(e.target.value)}}
                                        />
                                    </div>
                                </li>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>사용가능 포인트: {mbInfo && mbInfo['mb_point'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} P</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <TextField
                                            hiddenLabel
                                            id="filled-hidden-label-small"
                                            value={point}
                                            variant="filled"
                                            size="small"
                                            fullWidth
                                            type='number'
                                            onChange={(e) => {
                                                setPoint(parseInt(e.target.value))
                                            }}
                                            onBlur={() => {
                                                if(!point) return setPoint(0)
                                                let res = 0
                                                res= Math.floor(point / pointUnit) * pointUnit;
                                                let price = data.length > 0 ? data.reduce((result, item) => result + (item['ct_price'] * item['ct_qty']), 0) : 0

                                                if(res > mbInfo['mb_point']) {
                                                    setPoint(0)
                                                    setDialog('사용가능하신 포인트보다 입력하신 포인트가 높습니다.')
                                                    return 
                                                }

                                                if(res < minPoint) {
                                                    setPoint(0)
                                                    setDialog(`최소 사용 포인트는 ${minPoint} 입니다.`)
                                                    return
                                                }

                                                if(res > maxPoint) {
                                                    setPoint(0)
                                                    setDialog(`최대 사용 포인트는 ${maxPoint} 입니다.`)
                                                    return
                                                }

                                                if(res > price) {
                                                    setPoint(0)
                                                    setDialog('포인트가 주문하신금액을 초과 하였습니다.')
                                                    return
                                                }

                                                setPoint(res)

                                            }}
                                        />
                                    </div>
                                </li>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>배송메세지</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <input 
                                            type='text' 
                                            className={classes.appContentInput} 
                                            placeholder='내용을 입력해주세요.' 
                                            value={shopMemo}
                                            onChange={(e) => {setShopMemo(e.target.value)}}
                                        />
                                    </div>
                                </li>
                                <li className={classes.appListLi}>
                                    <div className={classes.paddingDiv}>
                                        <label className={classes.pilsooItem}>희망배송일</label>
                                    </div>
                                    <div className={classes.appContent}>
                                        <TextField
                                            type="date"
                                            value={hopeDate}
                                            sx={{ width: 220 }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={(e) => {
                                                let date = new Date(e.target.value);
                                                if (date.getDay() === 6 || date.getDay() === 0) return setDialog('주말 배송은 불가합니다.')
                                                setHopeDate(e.target.value)
                                            }}
                                        />
                                        <h3>이후로 배송 바랍니다. (* 토,일요일은 배송되지 않습니다.)</h3>
                                        <h3>희망배송일을 지정하지 않으신경우 {hopeDateAfter}일 이후 배송이 진행됩니다.</h3>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={classes.orderForm}>
                            <h3 className={classes.appListH3}>주문상품</h3>
                            <div className={classes.totalDiv}>
                                    <div className={classes.thead1}>
                                            <div 
                                                className={classes.tableTh}
                                                style={{flex: 3}}
                                            >
                                                상세정보
                                            </div>
                                            <div 
                                                className={classes.tableTh}
                                                style={{flex: 1}}
                                            >
                                                판매가
                                            </div>
                                            <div 
                                                className={classes.tableTh}
                                                style={{flex: 1}}
                                            >
                                                수량
                                            </div>
                                    </div>
                                    <div style={{width: '100%'}}>
                                        {data.length > 0 && data.map((itm) => (
                                            <OrderItm
                                                key={itm['ct_id']}
                                                ctPrice={itm['ct_price']}
                                                CtQty={itm['ct_qty']}
                                                itName={itm['it_name']}
                                                ItImg1={itm['it_img1']}
                                            />
                                        ))}
                                    </div>
                            </div>
                        <div className={classes.totalPriceDiv}>
                            <h1 className={classes.totalPriceLeftH1}>총 결제금액(배송비: {sendCost})</h1>
                            <h1 className={classes.totalPriceRightH1}>
                            {data.length > 0 ? 
                                (data.reduce((result, item) => result + (item['ct_price'] * item['ct_qty']), -point) + sendCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
                            0}원
                            </h1>
                        </div>
                        <div className={classes.btnDiv}>
                                
                                {!deliLoading ? (
                                    <>
                                    <button 
                                        className={classes.orderBtnLeft}
                                        onClick={() => {
                                            setDeliLoading(true)
                                            // 렉걸렸을때 중복주문 방지
                                            setTimeout(() => onOrder(), 1000);
                                        }}
                                    >
                                        결제하기
                                    </button> 
                                    <Link to="/Cart">
                                        <button 
                                            className={classes.orderBtnRight}
                                            style={{ marginLeft:'10px'}}
                                        >
                                            취소
                                        </button>
                                    </Link>
                                    </>
                                ) : (
                                    <div>
                                        주문처리가 진행중입니다...
                                    </div>
                                )}



                        </div>
                        </div> 
                    </div>
                </div>
            </div>

            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
                <DialogTitle id="alert-dialog-title">
                {dialog}
                </DialogTitle>
                <DialogActions>
                <Button onClick={() => setDialog('')} autoFocus>
                    확인
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={dialogQty.length === 0 ? false : true}
                onClose={() => setDialogQty([])}
            >
                <DialogTitle id="alert-dialog-title">
                재고가 부족한 상품이 있습니다.
                </DialogTitle>
                <DialogContent>
                    {dialogQty.length > 0 && (
                        dialogQty.map((itm, idx) => (
                            <DialogContentText key={idx}>
                                {itm['it_name']} (남은수량: {itm['it_qty']})
                            </DialogContentText>
                        ))
                    )}
                </DialogContent>
                <DialogActions>
                <Button onClick={() => setDialogQty([])} autoFocus>
                    확인
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}


const OrderItm = ({ctPrice, CtQty, itName, ItImg1}) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    return(
        <div className={classes.tableData}>
            <div className={classes.t1}>
                <img 
                    src={`${mainPath}/media/data/item/${ItImg1}`}
                    className={classes.productInformationImg}
                />
                <div className={classes.t3}>
                    <h1 className={classes.t5}>{itName}</h1>
                    <div className={classes.t4}>{ctPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원 </div>
                    <div className={classes.t4}>수량: {CtQty}</div>
                </div>
            </div>
                
            <div className={classes.t2}>
                {ctPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원 
            </div>
            <div className={classes.t2}>
                {CtQty}
            </div>
        </div>
    )
}



export default DeliveryInformation;